<template>
    <v-select
        v-model="variableValue"
        :items="variableList"
        :label="$t('Variable')"
        :item-text="variable => variable.name + ': ' + variable.value"
        item-value="code"
        :loading="loading"
        :disabled="loading"
        :error-messages="errorMessages"
    ></v-select>
</template>
<script>
import Utils from '@/ecm/common/Utils';
import VariableService from '@/services/VariableService';
import FieldType from '@/ecm/variables/FieldType';
export default {
    name: 'SearchVariableInput',
    props: {
        conditionItem: {
            type: Object,
            required: true
        },
        errorMessages: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            variableList: [],
            variableValue: null,
            loading: false
        };
    },
    async mounted() {
        await this.getVariableList(this.conditionItem.fieldType);
        this.variableValue = this.conditionItem.fieldValue;
    },
    methods: {
        async getVariableList(fieldType) {
            this.loading = true;
            this.variableList = await VariableService.getForSearch(fieldType);
            this.variableList.forEach(variable => {
                if (variable.type === FieldType.DateTime) {
                    variable.value = Utils.date.toUserFormatFromIso(variable.value, false);
                } else if (variable.type === FieldType.Numeric) {
                    const userDecSep = this.$store.getters['account/user'].MetricDecimalSep;
                    const userThouSep = this.$store.getters['account/user'].MetricThousandSep;
                    variable.value = Utils.number.toUserFormat(variable.value, userDecSep, userThouSep);
                }
            });
            this.loading = false;
        }
    },
    watch: {
        variableValue(newValue) {
            this.conditionItem.fieldValue = newValue;
            const displayValue = this.variableList.find(x => x.code === newValue);
            this.conditionItem.fieldDisplayValue = `${displayValue.name}: ${displayValue.value}`;
        },
        conditionItem: {
            deep: true,
            async handler(newConditionItem, oldConditionItem) {
                if (newConditionItem.fieldType !== oldConditionItem.fieldType) {
                    await this.getVariableList(newConditionItem.fieldType);
                }
            }
        }
    }
};
</script>
